import { useMemo, useState } from "react";
import Loading from "../Loading";
import { Notification, NotificationResponse, UserState } from "../../../_app/types";
import NotificationTabs from "./NotificationTabs";
import Box from "@mui/material/Box";
import usePage from "../../../hooks/usePage";
import Header from "../../../_modules/Header/Header";
import PageLayout from "../../../_components/PageLayout";
import { useApi } from "../../../_hooks/use-api";

interface Props {
  user: UserState;
  notifications: Notification[];
  onChange: (value: Notification[]) => void;
}

const fetchNotifications = async (
  api: ReturnType<typeof useApi>,
  accountId: string,
  page: number,
  size: number
): Promise<Notification[]> => {
  try {
    const response: NotificationResponse = await api.accountNotifications(accountId, page, size);
    return response.content;
  } catch (error) {
    throw error;
  }
};

const NotificationProvider = ({ user, onChange, notifications }: Props) => {
  const api = useApi();
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const { page, resetPage, addPage, observerRef } = usePage({ onInView: () => doLoad() });

  const sortNotificationsByTime = useMemo(() => {
    return notifications.sort((a, b) => b.eventTime - a.eventTime);
  }, [notifications]);

  const loadItems = async () => {
    setLoading(true);
    try {
      console.log(page);
      const newItems = await fetchNotifications(api, user.activeAccount.id, page, 20);
      onChange(newItems);
      setHasMore(newItems.length > 0);
    } catch (error) {
      console.error("Error loading more notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  const doLoad = () => {
    if (loading || !hasMore) return;
    loadItems();
    addPage();
  };

  return (
    <PageLayout
      header={<Header pageTitle={"notifications"} needBack hideButtons />}
      contentSx={{ paddingTop: "20px" }}
    >
      <NotificationTabs notifications={sortNotificationsByTime} ref={observerRef} />
      {loading && (
        <Box
          sx={{
            width: "100%",
            position: "fixed",
            bottom: "2%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Loading />
        </Box>
      )}
    </PageLayout>
  );
};

export default NotificationProvider;
